// src/pages/Home.jsx
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import NewsletterPopup from "../components/NewsletterPopup";

const LANGUAGE_STORAGE_KEY = "zedro_academy_language";

const HOME_COPY = {
  es: {
    marquee: [
      ["Actúa con orden.", "1 Co 14:40"],
      ["Construye con sabiduría.", "Pr 24:3"],
      ["Renueva tu manera de pensar.", "Ro 12:2"],
      ["Lleva lo aprendido a la práctica.", "Stg 1:22"],
      ["Planifica y actúa con responsabilidad.", "Pr 16:3"],
      ["Trabaja con integridad.", "Col 3:23"],
      ["Administra bien tu tiempo.", "Sal 90:12"],
      ["Escucha antes de responder.", "Pr 18:13"],
      ["Construye sobre fundamento.", "Mt 7:24"],
      ["Camina con verdad.", "3 Jn 1:4"],
    ],
    heroTitle: [
      "Piensa con claridad.",
      "Decide con criterio.",
      "Construye con propósito.",
    ],
    heroSubtitle:
      "ZEDRO Academy es una plataforma de formación práctica con fundamento cristiano, diseñada para conectar principios con decisiones, acciones y evidencia. Su visión integra vida, liderazgo y empresa.",
    heroSynthesis:
      "Formación práctica para pensar, decidir y construir con coherencia.",
    primaryCta: "Comienza tu prueba gratuita",
    secondaryCta: "Ver metodología",
    heroMeta: "• Vida • Liderazgo • Empresa •",

    tensionBig: [
      "Puedes aprender mucho.",
      "El verdadero reto es",
      "llevarlo a la práctica.",
    ],
    tensionQuote: [
      "La claridad orienta.",
      "La estructura convierte intención en avance.",
    ],
    tensionMicro:
      "ZEDRO Academy organiza recorridos que conectan comprensión, decisión, práctica y registro para que lo aprendido no se quede en una idea.",
    introTitle: "Una formación que integra vida, liderazgo y empresa.",
    introLead:
      "Lo que piensas influye en cómo decides, te relacionas, lideras, trabajas y construyes. ZEDRO Academy organiza una propuesta formativa para desarrollar criterio, responsabilidad y coherencia en esas dimensiones.",
    introLeadCompact:
      "La propuesta se desarrolla progresivamente en tres dimensiones conectadas, con una misma metodología y una orientación común.",
    pillars: [
      {
        title: "Vida, criterio y coherencia",
        text: "Pensamientos, decisiones, hábitos, relaciones y responsabilidad cotidiana.",
      },
      {
        title: "Liderazgo y gobierno",
        text: "Una línea en desarrollo sobre carácter, servicio, mayordomía, dirección e influencia responsable.",
      },
      {
        title: "Gestión empresarial",
        text: "Una línea en desarrollo sobre estrategia, personas, finanzas, experiencia del cliente y toma de decisiones.",
      },
      {
        title: "Fundamento cristiano",
        text: "La raíz que orienta principios, criterio y responsabilidad, y conecta la fe con decisiones concretas de la vida real.",
      },
    ],
    productEyebrow: "Disponible hoy en la membresía",
    productTitle: "Una experiencia práctica para pasar de la reflexión a la acción.",
    productSubtitle:
      "Actualmente, ZEDRO Academy reúne sistemas guiados de 28 días, micro-misiones, Bitácora personal y Conexión. Cada elemento cumple una función concreta dentro del proceso.",
    productHeroLabel: "Experiencia actual",
    productHeroTitle: "Una plataforma que organiza tu proceso.",
    productHeroText:
      "Contenido, práctica, registro y herramientas reunidos para ayudarte a avanzar con claridad, responsabilidad y continuidad.",
    productCards: [
      {
        img: "/assets/images/home/home-zedro-formacion-oracion-escenas.png",
        alt: "Personas utilizando los recorridos y herramientas actuales de ZEDRO Academy",
        label: "Sistemas de 28 días",
        title: "Cimientos ZEDRO",
        text: "Recorridos guiados para trabajar áreas concretas de la vida mediante formación, reflexión, micro-misiones y aplicación diaria.",
      },
      {
        img: "/assets/images/home/home-bitacora-zedro-proceso.png",
        alt: "Bitácora ZEDRO como espacio de registro y evidencia del proceso",
        label: "Registro y evidencia",
        title: "Bitácora ZEDRO",
        text: "Un espacio para conservar respuestas, decisiones, acciones y aprendizajes, y volver sobre ellos cuando necesites revisar tu avance.",
      },
      {
        img: "/assets/images/home/home-ecosistema-zedro-mobile.png",
        alt: "Conexión ZEDRO utilizada desde un teléfono",
        label: "Reflexión y oración",
        title: "Conexión ZEDRO",
        text: "Un espacio privado para ordenar pensamientos, explorar pasajes bíblicos, reflexionar y preparar una oración personal.",
      },
    ],
    productFooter:
      "La experiencia disponible hoy es el punto de partida. ZEDRO Academy desarrollará progresivamente nuevas rutas de liderazgo, gobierno y gestión empresarial.",
    methodTitle: "Una metodología para convertir comprensión en decisiones, acción y evidencia.",
    methodLead:
      "Cada recorrido combina formación, reflexión, micro-misiones y registro para ayudarte a comprender, ordenar, practicar y sostener lo aprendido en la vida diaria.",
    methodSteps: [
      {
        num: "01",
        title: "Comprender",
        text: "Recibes contenido claro y preguntas que te ayudan a examinar un área concreta de tu vida.",
      },
      {
        num: "02",
        title: "Ordenar",
        text: "Relacionas lo aprendido con tus pensamientos, prioridades y decisiones.",
      },
      {
        num: "03",
        title: "Practicar",
        text: "Lo conviertes en una acción concreta mediante micro-misiones y aplicación diaria.",
      },
      {
        num: "04",
        title: "Sostener",
        text: "Registras evidencia, revisas lo aprendido y desarrollas continuidad con responsabilidad.",
      },
    ],
    methodNote:
      "No es consumo pasivo. Es formación estructurada para pensar, decidir y actuar con mayor coherencia.",
    methodCta: "Ver metodología completa",
    manifestoEyebrow: "Nuestra orientación",
    manifestoTitle: "La verdad no reemplaza el criterio ni la acción: los orienta.",
    manifestoParagraphs: [
      "ZEDRO Academy conecta principios cristianos con carácter, responsabilidad y decisiones de la vida real. No ofrece fórmulas rápidas, promesas automáticas ni respuestas simplistas.",
      "Cada recorrido organiza contenidos, preguntas y prácticas para ayudar a pensar con mayor claridad, asumir decisiones y construir evidencia de lo aprendido.",
    ],
    manifestoClosing:
      "El propósito es formar criterio para vivir, liderar y construir con coherencia.",
    principlesTitle: "Principios para pensar, decidir y construir",
    principlesAria: "Ecosistema de principios",
    carouselAria: "Carrusel de principios",
    finalTitle: "Empieza por lo que puedes trabajar hoy.",
    finalText:
      "Conoce los recorridos y herramientas actualmente disponibles en ZEDRO Academy, y comienza un proceso estructurado para pensar con claridad, fortalecer tus decisiones y llevar lo aprendido a la práctica.",
    productHeroAlt:
      "Vista del ecosistema actualmente disponible en ZEDRO Academy",
  },
  fr: {
    marquee: [
      ["Agissez avec ordre.", "1 Co 14.40"],
      ["Construisez avec sagesse.", "Pr 24.3"],
      ["Renouvelez votre manière de penser.", "Rm 12.2"],
      ["Mettez en pratique ce que vous apprenez.", "Jc 1.22"],
      ["Planifiez et agissez avec responsabilité.", "Pr 16.3"],
      ["Travaillez avec intégrité.", "Col 3.23"],
      ["Gérez votre temps avec sagesse.", "Ps 90.12"],
      ["Écoutez avant de répondre.", "Pr 18.13"],
      ["Construisez sur des fondations solides.", "Mt 7.24"],
      ["Marchez dans la vérité.", "3 Jn 1.4"],
    ],
    heroTitle: [
      "Pensez avec clarté.",
      "Décidez avec discernement.",
      "Construisez avec intention.",
    ],
    heroSubtitle:
      "ZEDRO Academy est une plateforme de formation pratique à fondement chrétien, conçue pour relier les principes aux décisions, aux actions et aux preuves concrètes. Sa vision intègre la vie, le leadership et l’entreprise.",
    heroSynthesis:
      "Une formation pratique pour penser, décider et construire avec cohérence.",
    primaryCta: "Commencez votre essai gratuit",
    secondaryCta: "Voir la méthodologie",
    heroMeta: "• Vie • Leadership • Entreprise •",

    tensionBig: [
      "Vous pouvez beaucoup apprendre.",
      "Le véritable défi est",
      "de le mettre en pratique.",
    ],
    tensionQuote: [
      "La clarté donne une direction.",
      "La structure transforme l’intention en progrès.",
    ],
    tensionMicro:
      "ZEDRO Academy organise des parcours qui relient compréhension, décision, pratique et suivi afin que ce qui est appris ne reste pas une simple idée.",
    introTitle: "Une formation qui relie la vie, le leadership et l’entreprise.",
    introLead:
      "Votre manière de penser influence vos décisions, vos relations, votre leadership, votre travail et ce que vous construisez. ZEDRO Academy organise une proposition de formation pour développer discernement, responsabilité et cohérence dans ces dimensions.",
    introLeadCompact:
      "La proposition se développe progressivement autour de trois dimensions reliées par une même méthodologie et une orientation commune.",
    pillars: [
      {
        title: "Vie, discernement et cohérence",
        text: "Pensées, décisions, habitudes, relations et responsabilité au quotidien.",
      },
      {
        title: "Leadership et gouvernance",
        text: "Une ligne en développement sur le caractère, le service, l’intendance, la direction et l’influence responsable.",
      },
      {
        title: "Gestion d’entreprise",
        text: "Une ligne en développement sur la stratégie, les personnes, les finances, l’expérience client et la prise de décision.",
      },
      {
        title: "Fondement chrétien",
        text: "La racine qui oriente les principes, le discernement et la responsabilité, en reliant la foi aux décisions concrètes de la vie réelle.",
      },
    ],
    productEyebrow: "Disponible actuellement dans l’abonnement",
    productTitle: "Une expérience pratique pour passer de la réflexion à l’action.",
    productSubtitle:
      "ZEDRO Academy réunit actuellement des systèmes guidés de 28 jours, des micro-missions, une Bitácora personnelle et Connexion. Chaque élément remplit une fonction précise dans le processus.",
    productHeroLabel: "Expérience actuelle",
    productHeroTitle: "Une plateforme qui organise votre parcours.",
    productHeroText:
      "Contenu, pratique, suivi et outils sont réunis pour vous aider à avancer avec clarté, responsabilité et continuité.",
    productCards: [
      {
        img: "/assets/images/home/home-zedro-formacion-oracion-escenas.png",
        alt: "Personnes utilisant les parcours et les outils actuellement offerts par ZEDRO Academy",
        label: "Systèmes de 28 jours",
        title: "Fondements ZEDRO",
        text: "Des parcours guidés pour travailler des domaines concrets de la vie au moyen de formation, de réflexion, de micro-missions et d’application quotidienne.",
      },
      {
        img: "/assets/images/home/home-bitacora-zedro-proceso.png",
        alt: "Bitácora ZEDRO comme espace de suivi et de preuves du parcours",
        label: "Suivi et preuves",
        title: "Bitácora ZEDRO",
        text: "Un espace pour conserver réponses, décisions, actions et apprentissages, puis y revenir lorsque vous souhaitez revoir votre progression.",
      },
      {
        img: "/assets/images/home/home-ecosistema-zedro-mobile.png",
        alt: "Connexion ZEDRO utilisée depuis un téléphone",
        label: "Réflexion et prière",
        title: "Connexion ZEDRO",
        text: "Un espace privé pour mettre de l’ordre dans vos pensées, explorer des passages bibliques, réfléchir et préparer une prière personnelle.",
      },
    ],
    productFooter:
      "L’expérience offerte aujourd’hui est le point de départ. ZEDRO Academy développera progressivement de nouveaux parcours de leadership, de gouvernance et de gestion d’entreprise.",
    methodTitle:
      "Une méthodologie pour transformer la compréhension en décisions, en action et en preuves concrètes.",
    methodLead:
      "Chaque parcours combine formation, réflexion, micro-missions et suivi afin de vous aider à comprendre, ordonner, pratiquer et soutenir ce que vous apprenez dans la vie quotidienne.",
    methodSteps: [
      {
        num: "01",
        title: "Comprendre",
        text: "Vous recevez un contenu clair et des questions qui vous aident à examiner un domaine concret de votre vie.",
      },
      {
        num: "02",
        title: "Ordonner",
        text: "Vous reliez ce que vous apprenez à vos pensées, à vos priorités et à vos décisions.",
      },
      {
        num: "03",
        title: "Pratiquer",
        text: "Vous le transformez en une action concrète au moyen de micro-missions et d’une application quotidienne.",
      },
      {
        num: "04",
        title: "Soutenir",
        text: "Vous consignez des preuves, révisez ce que vous apprenez et développez une continuité responsable.",
      },
    ],
    methodNote:
      "Ce n’est pas une consommation passive. C’est une formation structurée pour penser, décider et agir avec plus de cohérence.",
    methodCta: "Voir la méthodologie complète",
    manifestoEyebrow: "Notre orientation",
    manifestoTitle:
      "La vérité ne remplace ni le discernement ni l’action : elle les oriente.",
    manifestoParagraphs: [
      "ZEDRO Academy relie les principes chrétiens au caractère, à la responsabilité et aux décisions de la vie réelle. Elle n’offre ni formules rapides, ni promesses automatiques, ni réponses simplistes.",
      "Chaque parcours organise des contenus, des questions et des pratiques pour aider à penser avec plus de clarté, à assumer ses décisions et à construire des preuves de ce qui est appris.",
    ],
    manifestoClosing:
      "Le but est de former le discernement afin de vivre, de diriger et de construire avec cohérence.",
    principlesTitle: "Des principes pour penser, décider et construire",
    principlesAria: "Écosystème de principes",
    carouselAria: "Carrousel de principes",
    finalTitle: "Commencez par ce que vous pouvez travailler aujourd’hui.",
    finalText:
      "Découvrez les parcours et les outils actuellement offerts par ZEDRO Academy, puis commencez un processus structuré pour penser avec clarté, fortifier vos décisions et mettre en pratique ce que vous apprenez.",
    productHeroAlt:
      "Vue de l’écosystème actuellement offert dans ZEDRO Academy",
  },
};

function resolveInitialLanguage() {
  if (typeof window === "undefined") return "es";

  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (["es", "fr"].includes(savedLanguage)) return savedLanguage;

  const params = new URLSearchParams(window.location.search);
  const queryLang = params.get("lang");
  if (queryLang && queryLang.toLowerCase().startsWith("fr")) return "fr";
  if (queryLang && queryLang.toLowerCase().startsWith("es")) return "es";

  return "es";
}

export default function Home() {
  const [language, setLanguage] = React.useState(resolveInitialLanguage);

  React.useEffect(() => {
    if (typeof window === "undefined") return;

    function syncLanguage(nextLanguage) {
      if (["es", "fr"].includes(nextLanguage)) {
        setLanguage(nextLanguage);
      } else {
        setLanguage("es");
      }
    }

    function handleLanguageEvent(event) {
      syncLanguage(event?.detail?.language);
    }

    function handleStorage(event) {
      if (event.key === LANGUAGE_STORAGE_KEY) {
        syncLanguage(event.newValue);
      }
    }

    syncLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
    window.addEventListener("zedro:languagechange", handleLanguageEvent);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("zedro:languagechange", handleLanguageEvent);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const copy = HOME_COPY[language] || HOME_COPY.es;

  const marqueeItems = copy.marquee.map(([text, verse]) => (
    <>
      {text} <span className="verse-ref">{verse}</span>
    </>
  ));

  const marqueeLoop = [...marqueeItems, ...marqueeItems, ...marqueeItems];

  const motionScopeRef = useRef(null);

  useEffect(() => {
    document.documentElement.lang = language === "fr" ? "fr-CA" : "es";
  }, [language]);

  useEffect(() => {
    const root = motionScopeRef.current;
    if (!root) return;

    const els = root.querySelectorAll(".fade-up");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
          else e.target.classList.remove("is-visible");
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const [openPopup, setOpenPopup] = React.useState(false);

  React.useEffect(() => {
    // Popup desactivado durante pre-lanzamiento.
    // Se activará cuando la estrategia de captación esté definida.
    setOpenPopup(false);
  }, []);

  return (
    <div className="home-premium" ref={motionScopeRef}>
      {/* =========================
          HERO
      ========================== */}
      <section className="hp-hero">
        <div className="hp-heroMedia">
          <div
            className="hp-heroPoster"
            style={{ backgroundImage: "url(/assets/images/zedro-hero-poster.jpg)" }}
          />
          <div className="hp-heroOverlay" />
        </div>

        <div className="hp-heroInner">
          <div className="fade-up">
            <h1 className="hp-heroTitle hp-heroTitleStructured">
              {copy.heroTitle.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </h1>

            <p className="hp-heroSubtitle">{copy.heroSubtitle}</p>

            <p className="hp-heroSynthesis">{copy.heroSynthesis}</p>

            <div className="hp-heroCtas">
              <Link className="hp-ctaPrimary" to="/store">
                {copy.primaryCta}
              </Link>

              <Link className="hp-ctaSecondary" to="/metodologia">
                {copy.secondaryCta}
              </Link>
            </div>

            <div className="hp-heroMeta">{copy.heroMeta}</div>

            <div className="hp-heroNote">{copy.heroNote}</div>
          </div>
        </div>
      </section>

      {/* =========================
          TENSIÓN
      ========================== */}
      <section className="hp-section hp-tension hp-section--alt">
        <div className="hp-container">
          <div className="hp-tensionGrid">
            <div className="hp-tensionBig fade-up">
              {copy.tensionBig.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </div>

            <div className="hp-tensionSmall fade-up">
              <div className="hp-tensionQuote">
                {copy.tensionQuote.map((line) => (
                  <div key={line}>{line}</div>
                ))}
              </div>

              <div className="hp-tensionMicro">{copy.tensionMicro}</div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          ZEDRO Academy ES…
      ========================== */}
      <section className="hp-section hp-intro">
        <div className="hp-container">
          <div className="hp-introGrid">
            <div className="hp-introCopy fade-up">
              <h2 className="hp-h2">{copy.introTitle}</h2>

              <p className="hp-lead">{copy.introLead}</p>

              <p className="hp-lead hp-lead--compact">{copy.introLeadCompact}</p>
            </div>

            <div className="hp-pillars hp-pillars--stacked fade-up">
              {/* Identidad */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 12a4.2 4.2 0 1 0-4.2-4.2A4.2 4.2 0 0 0 12 12Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M4.5 20c1.9-4.2 13.1-4.2 15 0"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[0].title}</div>
                  <div className="hp-cardText">{copy.pillars[0].text}</div>
                </div>
              </div>

              {/* Orden */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4.5 4.5h6.8v6.8H4.5zM12.7 4.5h6.8v6.8h-6.8zM4.5 12.7h6.8v6.8H4.5zM12.7 12.7h6.8v6.8h-6.8z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[1].title}</div>
                  <div className="hp-cardText">{copy.pillars[1].text}</div>
                </div>
              </div>

              {/* Acción */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M13 2 4.8 13.2H12L11 22l8.2-11.2H12.1Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[2].title}</div>
                  <div className="hp-cardText">{copy.pillars[2].text}</div>
                </div>
              </div>

              {/* Multiplicación */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 3l1.2 4.2L17.4 8.4l-4.2 1.2L12 13.8l-1.2-4.2L6.6 8.4l4.2-1.2L12 3Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.2 13.2l.7 2.5 2.5.7-2.5.7-.7 2.5-.7-2.5-2.5-.7 2.5-.7.7-2.5Z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinejoin="round"
                      opacity=".9"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[3].title}</div>
                  <div className="hp-cardText">{copy.pillars[3].text}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          PRUEBA VISUAL DEL PRODUCTO
      ========================== */}
      <section className="hp-section hp-productShowcase">
        <div className="hp-container">
          <div className="hp-productHeader fade-up">
            <div className="hp-eyebrow">{copy.productEyebrow}</div>

            <h2 className="hp-h2">{copy.productTitle}</h2>

            <p className="hp-subtitle">{copy.productSubtitle}</p>
          </div>

          <div className="hp-productHero fade-up">
            <div className="hp-productHeroCopy">
              <span className="hp-productLabel">{copy.productHeroLabel}</span>
              <h3>{copy.productHeroTitle}</h3>
              <p>{copy.productHeroText}</p>
            </div>

            <div className="hp-productHeroMedia">
              <img
                className="hp-productHeroImage"
                src="/assets/images/home/home-ecosistema-zedro-desktop.png"
                alt={copy.productHeroAlt}
                loading="lazy"
              />
            </div>
          </div>

          <div className="hp-productGrid fade-up">
            {copy.productCards.map((card) => (
              <article className="hp-productCard" key={card.title}>
                <div className="hp-productCardMedia">
                  <img src={card.img} alt={card.alt} loading="lazy" />
                </div>

                <div className="hp-productCardBody">
                  <span className="hp-productLabel">{card.label}</span>
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="hp-productFooter fade-up">{copy.productFooter}</div>
        </div>
      </section>

      {/* =========================
          METODOLOGÍA
      ========================== */}
      <section id="metodologia" className="hp-section hp-method hp-section--alt">
        <div className="hp-container fade-up">
          <h2 className="hp-h2">{copy.methodTitle}</h2>

          <p className="hp-lead">{copy.methodLead}</p>

          <div className="hp-steps">
            {copy.methodSteps.map((step) => (
              <div className="hp-step" key={step.num}>
                <div className="hp-stepNum">{step.num}</div>
                <div className="hp-stepBody">
                  <div className="hp-stepTitle">{step.title}</div>
                  <div className="hp-stepText">{step.text}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="hp-methodNote">{copy.methodNote}</div>

          <div className="hp-methodCta">
            <Link className="hp-ctaSecondary" to="/metodologia">
              {copy.methodCta}
            </Link>
          </div>
        </div>
      </section>

      {/* =========================
          DECLARACIÓN ZEDRO
      ========================== */}
      <section className="hp-section hp-manifestoSection">
        <div className="hp-container">
          <div className="hp-manifestoCard fade-up">
            <div className="hp-eyebrow hp-eyebrow--center">{copy.manifestoEyebrow}</div>

            <h2 className="hp-h2 hp-manifestoTitle">{copy.manifestoTitle}</h2>

            <div className="hp-manifestoText hp-manifestoText--center">
              {copy.manifestoParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              <p className="hp-manifestoClosing">{copy.manifestoClosing}</p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          PRINCIPIOS
      ========================== */}
      <section className="hp-section hp-marqueeSection" aria-label={copy.principlesAria}>
        <div className="hp-container">
          <div className="hp-marqueeTitle fade-up">{copy.principlesTitle}</div>
        </div>

        <div className="marquee" aria-label={copy.carouselAria}>
          <div className="marquee__track marquee__track--a">
            {marqueeLoop.map((t, i) => (
              <span className="marquee__item" key={`principle-a-${i}`}>
                {t}
              </span>
            ))}
          </div>

          <div className="marquee__track marquee__track--b" aria-hidden="true">
            {marqueeLoop.map((t, i) => (
              <span className="marquee__item" key={`principle-b-${i}`}>
                {t}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          CTA FINAL
      ========================== */}
      <section className="hp-section hp-finalCta">
        <div className="hp-container fade-up">
          <h2 className="hp-h2">{copy.finalTitle}</h2>

          <p className="hp-finalText">{copy.finalText}</p>

          <div className="hp-finalActions">
            <Link className="hp-ctaPrimary" to="/store">
              {copy.primaryCta}
            </Link>

            <Link className="hp-ctaSecondary" to="/metodologia">
              {copy.secondaryCta}
            </Link>
          </div>
        </div>
      </section>

      <NewsletterPopup open={openPopup} onClose={() => setOpenPopup(false)} />
    </div>
  );
}
